<i18n>
  {
    "pt_BR": {
      "loading": "Carregando...",
      "error": "Ops, tivemos algum erro por aqui! Por favor atualize a página =)"
    }
  }
</i18n>

<template>
  <span v-t="status === null ? 'loading' : 'error'" v-if="! status"></span>
</template>

<script>
  export default {
    props: {
      status: {
        required: true,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Status.vue